import {
  GET_MATCH_CARD_DETAILS_REQUEST,
  GET_MATCH_CARD_DETAILS_SUCCESS,
  GET_MATCH_CARD_DETAILS_FAILURE,
  RESET_MATCH_CARD,
  LIVE_SCORES_WS_UPDATE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
  cache: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MATCH_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        data: { ...action.payload },
        isLoading: false,
        error: null,
        cache: {
          ...state.cache,
          [action.payload.eventId || action.eventId]: {
            data: action.payload,
            timestamp: Date.now()
          }
        }
      };
    case GET_MATCH_CARD_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case LIVE_SCORES_WS_UPDATE: {
      const { payload: { value } } = action;
      if (value.aggregate || value.aggregateScores) {

        if (state.data.matchCode && value.sbsEventId && state.data.matchCode !== value.sbsEventId) {
          return state;
        }
        
        const aggregateData = value.aggregate || value.aggregateScores;
        const updatedData = {
          ...state.data,
          aggregate: {
            homeTeam: aggregateData.homeTeam,
            awayTeam: aggregateData.awayTeam
          }
        };
        return {
          ...state,
          data: updatedData,
          cache: {
            ...state.cache,
            [state.data.eventId]: {
              data: updatedData,
              timestamp: Date.now()
            }
          }
        };
      }
      return state;
    }
    case RESET_MATCH_CARD:
      return { ...initialState, cache: state.cache };

    default:
      return state;
  }
};
